import "./style.css"

type TButonProps = {
    text: string
    url:string,
    status:boolean
}

export const Button = ({url, status, text}:TButonProps) => {
    const className = status ? "active" : "inactive";

    var action = () => {}
    if (status) {
        action = () => {window.location.href = url;}
    }

    return (
        <div className="right">
            <button className={className} onClick={action}>{text}</button>
        </div>
    )
}